module.exports = __webpack_public_path__ + "static/img/2.9c7d369.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/2.jpg
// module id = 9waq
// module chunks = 0